import React from 'react';
import {
  translate as t,
} from 'admin-on-rest';
import {
  Card,
  CardText,
  TextField,
} from 'material-ui';
import plz from 'await-plz';
import Dropzone from 'react-dropzone';
import TranslatableInput from './inputs/TranslatableInput';
import { uploadToS3 } from '../../client/addUploadCapability';

const defaultStyle = {
  dropZone: {
    background: '#efefef',
    cursor: 'pointer',
    padding: '1rem',
    textAlign: 'center',
    color: '#999',
  },
  imgDiv: {
    // display: 'flex',
    // justifyContent: 'center',
    // margin: '0',
    maxHeight: '250px',
    position: 'relative',
  },
  img: {
    maxHeight: '250px',
  },
};

class Image extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textUrl: this.props.values ? this.props.values.url : '',
      url: this.props.values ? this.props.values.url : '',
    };
  }

  onDrop = async (accepted) => { // eslint-disable-line
    const [files] = accepted.map((file) => ({ file, key: 'web-site-uploads' }));
    const [err, res] = await plz(uploadToS3(files, files.file.name, 'web-site-images'));
    if (err) return console.log('err');
    if (!res) return console.log('no res found', res);
    this.setState({ url: res.imageUrl, textUrl: res.imageUrl });
    this.props.onChange(this.props.prefix ? `${this.props.prefix}.url` : 'url', this.props.id, res.imageUrl);
  };

  handleTextChange = ({ target: { value } }, id) => {
    this.setState({ textUrl: value });
    this.props.onChange(this.props.prefix ? `${this.props.prefix}.url` : 'url', id, value);
  }

  render() {
    const { id, onChange, prefix = '', values, translate } = this.props;
    const { url, textUrl } = this.state;
    return (
      <Card>
        <CardText>
          <TextField
            floatingLabelText={translate('website.imageUrl')}
            defaultValue={values ? values.url : url}
            value={textUrl}
            onChange={(e) => this.handleTextChange(e, id)} // onChange(prefix ? `${prefix}.url` : 'url', id, e.target.value)}
            fullWidth
          />
          <Dropzone
            onDrop={this.onDrop}
            style={defaultStyle.dropZone}
          >
            {translate('choose.item', { item: translate('file') })}
          </Dropzone>

          <div style={defaultStyle.imgDiv}>
            <img style={defaultStyle.img} src={url && url} alt="" />
          </div>

          <TranslatableInput
            id={id}
            values={values && values.alt}
            name="alt"
            options={{ multiline: false }}
            onChange={(val) => onChange(prefix ? `${prefix}.alt` : 'alt', id, val)}
            label={translate('website.alt')}
          />
        </CardText>
      </Card>
    );
  }
}

export default t(Image);
